import { render, staticRenderFns } from "./porscheNav.vue?vue&type=template&id=36937344&scoped=true&"
import script from "./porscheNav.vue?vue&type=script&lang=js&"
export * from "./porscheNav.vue?vue&type=script&lang=js&"
import style0 from "./porscheNav.vue?vue&type=style&index=0&id=36937344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36937344",
  null
  
)

export default component.exports